import React from "react";

import { Grid } from "Common/Grid";
import ScrollToTopOnMount from "Common/ScrollToTopOnMount";

import LoadingOverlay from "./shared/LoadingOverlay";

const BlankQuotePageDumb = () => (
  <div>
    <Grid>
      <LoadingOverlay />
      <ScrollToTopOnMount />
    </Grid>
  </div>
);

export default BlankQuotePageDumb;
